/*
Author: Hoi Tak Leung
Email: hoi.leung@greedy.mx
Last Update: 26/09/2023
*/

import React from "react";

import { Typography, Container, Box } from "@mui/material";

import "./LegalDocument.css";
import { useLanguageContext } from "../../../context/languageContext";
import { textlanguages } from "../../../data/textOfThePage";

export default function Cookies() {
  const { languageSelected } = useLanguageContext();

  return (
    <Container>
      <Typography variant="h3" className="document-header">
        {textlanguages[languageSelected].legal.cookies.title}
      </Typography>
      <Typography variant="h6" className="document-content">
        {textlanguages[languageSelected].legal.cookies.introduction[0]}{" "}
        <span style={{ fontWeight: "bold" }}>
          {textlanguages[languageSelected].legal.cookies.introduction[1]}
        </span>{" "}
        {textlanguages[languageSelected].legal.cookies.introduction[2]}{" "}
        <a
          style={{ color: "#005587" }}
          href={textlanguages[languageSelected].legal.cookies.introduction[3]}
        >
          {textlanguages[languageSelected].legal.cookies.introduction[3]}
        </a>{" "}
        {textlanguages[languageSelected].legal.cookies.introduction[4]}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[0].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.cookies.sections[0]
            .paragraphs[0]
        }
        <span style={{ fontWeight: "bold" }}>
          {" "}
          {
            textlanguages[languageSelected].legal.cookies.sections[0]
              .paragraphs[1]
          }
        </span>{" "}
        {
          textlanguages[languageSelected].legal.cookies.sections[0]
            .paragraphs[2]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.cookies.sections[0]
            .paragraphs[3]
        }{" "}
        <span style={{ fontWeight: "bold" }}>
          {
            textlanguages[languageSelected].legal.cookies.sections[0]
              .paragraphs[4]
          }
        </span>{" "}
        {
          textlanguages[languageSelected].legal.cookies.sections[0]
            .paragraphs[5]
        }
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[1].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.cookies.sections[1]
            .paragraphs[0]
        }
      </Typography>
      <Box ml="30px" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[1].list.map(
          (list) => (
            <LineNumber
              number={list.number}
              boldText={list.boldText}
              text={list.text}
            />
          )
        )}
      </Box>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[2].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.cookies.sections[2]
            .paragraphs[0]
        }
      </Typography>
      <Box ml="30px" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[2].dotList.map(
          (list) => (
            <DotLine number="•" text={list} />
          )
        )}
      </Box>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[3].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.cookies.sections[3]
            .paragraphs[0]
        }
      </Typography>
      <Box ml="30px" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[3].links.map(
          (link) => (
            <DotLine number="•" text={link.text} link={link.url} />
          )
        )}
      </Box>
      <Typography variant="h6" className="document-content" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[3].note}
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[4].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.cookies.sections[4]
            .paragraphs[0]
        }
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[5].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.cookies.sections[5]
            .paragraphs[0]
        }
      </Typography>
      <Typography variant="h6" className="document-content" mt="20px">
        {
          textlanguages[languageSelected].legal.cookies.sections[5]
            .paragraphs[1]
        }
      </Typography>
      <Typography variant="h4" className="document-header" mt="20px">
        {textlanguages[languageSelected].legal.cookies.sections[6].header}
      </Typography>
      <Typography variant="h6" className="document-content">
        {
          textlanguages[languageSelected].legal.cookies.sections[6]
            .paragraphs[0]
        }
      </Typography>
      <Typography
        variant="h6"
        className="document-content"
        sx={{ fontWeight: "bold", mt: "20px" }}
      >
        {
          textlanguages[languageSelected].legal.cookies.sections[6].contact
            .email
        }
      </Typography>
      <Typography
        variant="h6"
        className="document-content"
        sx={{ fontWeight: "bold", mt: "20px" }}
      >
        {
          textlanguages[languageSelected].legal.cookies.sections[6].contact
            .address
        }
      </Typography>
      <Typography
        variant="h6"
        className="document-content"
        sx={{ fontWeight: "bold", mt: "20px" }}
      >
        {textlanguages[languageSelected].legal.cookies.sections[6].lastUpdate}
      </Typography>
    </Container>
  );
}

const LineNumber = ({ number, boldText, text }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          alignItems: "start",
          width: "40px",
          minWidth: "40px",
        }}
      >
        {number}
      </Typography>
      <Typography variant="h6" className="document-content">
        <span style={{ fontWeight: "bold" }}>{boldText}</span> {text}
      </Typography>
    </Box>
  );
};

const DotLine = ({ number, text, link }) => {
  return (
    <Box sx={{ display: "flex" }}>
      <Typography
        variant="h6"
        sx={{
          display: "flex",
          alignItems: "start",
          width: "40px",
          minWidth: "40px",
        }}
      >
        {number}
      </Typography>
      {link ? (
        <Typography variant="h6" className="document-content">
          <a
            style={{ color: "#005587" }}
            target="_blank"
            rel="noreferrer"
            href={link}
          >
            {text}
          </a>
        </Typography>
      ) : (
        <Typography variant="h6" className="document-content">
          {text}
        </Typography>
      )}
    </Box>
  );
};
